let clientId;

export const setClientId = id => {
  clientId = id;
};

export const getClientId = () => clientId;
